export type LiquidityType = 'Add' | 'Remove' | 'Bond' | 'Unbond';
export const BONDING_FEE = 0.05;
